import e from"../../node_modules/style-inject/dist/style-inject.es.js";var o={"destination-carousel-component":"_destination-carousel-component_1hk5b_1"};e("._destination-carousel-component_1hk5b_1{position:relative}");export{o as default};
//# sourceMappingURL=destination-carousel.module.less.js.map
